import { ConfirmationAction } from '@app/components/ConfirmationAction';
import { useToast } from '@app/core/notifications';
import { Device } from '@mi-front/core';
import { useAsyncViewCtx } from '@mi-front/ui';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { Button } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { apiClient } from '../../../../../api';

interface PropsP {
  readonly device: Device;
  readonly restart: () => Promise<void>;
}

export function DeviceRestartP(p: PropsP) {
  const { $t } = useIntl();
  const { notifyInfo } = useToast();

  return (
    <ConfirmationAction
      message={$t({
        id: 'streamerBox.viewScreen.actions.reboot.confirm',
        defaultMessage: '¿Desea realmente reiniciar el dispositivo?',
      })}
      onConfirm={async () => {
        await p.restart();
        notifyInfo(
          $t({
            id: 'streamerBox.viewScreen.actions.reboot.done',
            defaultMessage: 'Solicitud de reinicio enviada',
          }),
        );
      }}
    >
      {({ onClick }) => (
        <Button size="small" onClick={onClick} startIcon={<RestartAltIcon />}>
          <FormattedMessage
            id="streamerBox.viewScreen.actions.reboot.btn"
            defaultMessage="Reiniciar"
          />
        </Button>
      )}
    </ConfirmationAction>
  );
}

export function DeviceRestart(p: { device: Device }) {
  const { reload } = useAsyncViewCtx();

  return (
    <DeviceRestartP
      device={p.device}
      restart={async () => {
        await apiClient.streamerBox.restartDevice(p.device.id);
        reload();
      }}
    />
  );
}
